import React, { useRef, useState } from 'react';
import { Button, Typography, Box, useMediaQuery } from '@mui/material';
// import PlayArrowIcon from '@mui/material/Icon/PlayArrow';
import styles from './quickcam-capture.module.scss';
import {
  SummaryVideo,
  ThumbnailSummary,
  IconMute,
  IconUnmute,
} from '../../../../assets/images';

const QuickCamCapture: React.FC = () => {
  const isMobile = useMediaQuery('(max-width:768px)');

  const videoRef = useRef<HTMLVideoElement | null>(null);
  const [muted, setMuted] = useState(true);
  const [isPlaying, setIsPlaying] = useState(false);

  const handlePlayPause = () => {
    if (!videoRef.current) return;

    if (videoRef.current.paused) {
      videoRef.current.play().catch(err => {
        console.error('Failed to play video:', err);
      });
    } else {
      videoRef.current.pause();
    }
  };

  const handleActions = (step: number, ended: boolean) => {
    console.log('Video ended, handle actions here.');
  };

  return (
    <Box className={styles.container}>
      <Box className={styles.contentWrapper}>
        <Box
          display="flex"
          flexDirection={isMobile ? 'column' : 'row'}
          alignItems="center"
          justifyContent="space-between"
          gap={5}
        >
          <Box>
            <Typography variant="h3" className={styles.heading}>
              The QuickCam Camera Experience!
            </Typography>
            <ul className={styles.featureList}>
              <li>Multi-Patented Camera App</li>
              <li>Premium Free Trial in Beta Test</li>
              <li>Heart of the QuickCam Ecosystem</li>
              <li>
                Perpetual Promotional Pump for Quickie and Speedy Community Meme
                Coins
              </li>
              <li>Crypto Tipping</li>
              <li>Unlock Your Earning Potential!</li>
            </ul>
          </Box>

          <Box className={styles.phoneWrapper}>
            <Box className={styles.phoneContainer}>
              <Box className={styles.phoneNotch}> </Box>
              {/* <img alt="Phone" className={styles.phoneImage} /> */}
              <video
                ref={videoRef}
                muted={muted}
                loop
                autoPlay
                controls={false}
                playsInline
                key={SummaryVideo}
                className={styles.phoneVideo}
                poster={ThumbnailSummary}
                onPlay={() => setIsPlaying(true)}
                onPause={() => setIsPlaying(false)}
              >
                <source src={SummaryVideo} type="video/mp4" />
                <track
                  kind="captions"
                  srcLang="en"
                  src="/ss/srt.srt"
                  label="English"
                  default
                />
                Your browser does not support the video tag.
              </video>
              <button
                type="button"
                onClick={() => setMuted(!muted)}
                className={styles.videoMuteImage}
                aria-label={muted ? 'Unmute video' : 'Mute video'}
              >
                <img src={muted ? IconMute : IconUnmute} alt="" />
              </button>
              <button
                type="button"
                onClick={handlePlayPause}
                className={styles.playPauseButton}
                aria-label={isPlaying ? 'Pause video' : 'Play video'}
              >
                <div className={styles.iconCircle}>
                  <span
                    className={isPlaying ? styles.pauseIcon : styles.playIcon}
                  />
                </div>
                <span className={styles.playText}>
                  {isPlaying ? 'Pause' : 'Play'}
                </span>
              </button>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default QuickCamCapture;
